module.exports = __webpack_public_path__ + "static/media/html.39685834.png";